import MenuIcon from "@mui/icons-material/Menu";
import {
  Box,
  Container,
  Drawer,
  IconButton,
  useMediaQuery,
} from "@mui/material";
import { useEffect, useState } from "react";

export const CustomDrawer = ({
  children,
  btnSx,
  color = "background.secondary",
  isRequestService,
  navScrolled,
}) => {
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const isLargeFlag = useWidthFlag();

  useEffect(() => {
    if (isLargeFlag) {
      setMobileOpen(false);
    }
  }, [isLargeFlag]);
  return (
    <>
      <Container
        sx={{
          display: { xs: "initial", lg: "none" },
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: 1,
          }}
        >
          <Box>
            <img
              src={
                isRequestService
                  ? navScrolled
                    ? "/images/layout/logo.png"
                    : "/images/layout/logo.png"
                  : "/images/layout/logo.png"
              }
              style={{ maxWidth: "140px" }}
              alt=""
            />
          </Box>
          <IconButton
            size="small"
            onClick={handleDrawerToggle}
            sx={{
              zIndex: 9,
              ...btnSx,
            }}
          >
            <MenuIcon />
          </IconButton>
        </Box>
      </Container>
      {mobileOpen ? (
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true,
          }}
          sx={{ display: { xs: "block", lg: "none" } }}
          PaperProps={{
            sx: {
              backgroundColor: color,
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              pt: 5,
            },
          }}
        >
          {children}
        </Drawer>
      ) : (
        <Box sx={{ display: { xs: "none", lg: "block" }, width: 1 }}>
          {children}
        </Box>
      )}
    </>
  );
};

const useWidthFlag = () => {
  const [isLarge, setIsLarge] = useState(false);
  const isLG = useMediaQuery("(min-width: 1024px)");

  useEffect(() => {
    setIsLarge(isLG);
  }, [isLG]);

  return isLarge;
};
